import React from 'react';
import { ActiveQuickLinkTrayType } from 'src/api/config/cms/getActiveQuickLinkTray';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { observer } from 'src/utils/mobx-react';
import { SportName, NavSportWrapper, ImageWrapper, LinkWrapper } from './QuickLinkTray.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';

interface QuickLinkTrayItemType {
    link: ActiveQuickLinkTrayType;
}

export const QuickLinkTrayItem = observer('QuickLinkTrayItem', (props: QuickLinkTrayItemType) => {
    const common = useCommon();
    const appCasinoState = AppCasinoState.get(common);

    const starRouter = StarRouter.get(common);
    const configState = ConfigComponents.get(common).config;

    const { link } = props;
    const { redirect_option, direct_url } = link;

    const direct_url_view = direct_url ?? '';

    const handleMatchUrl = (): void => {
        if (direct_url_view === '') return;
        starRouter.handleUrlRedirection(direct_url_view);
    };

    const handleRedirect = (): void => {
        const { redirect_option, event_id, competition_id, sport, casino_game_id } = props.link;
        const event_id_view = event_id ?? null;
        const competition_id_view = competition_id ?? null;
        const casino_game_id_view = casino_game_id ?? null;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        const sport_view = sport ?? '';

        if (redirect_option === 'sport' && sport_view !== '') {
            starRouter.redirectToSportPage(sport_view);
            return;
        }

        if (redirect_option === 'event-id' && event_id_view !== null) {
            starRouter.redirectToEvent(event_id_view);
            return;
        }

        if (redirect_option === 'competition-id' && competition_id_view !== null && sport_view !== '') {
            starRouter.redirectToCompetitionPage(competition_id_view, sport_view);
            return;
        }

        if (redirect_option === 'casino-game-id' && casino_game_id_view !== null) {
            starRouter.redirectToCasinoPage();
            appCasinoState.gameStoreExt.getGameModel(casino_game_id_view)?.startGame();
        }
    };

    if (redirect_option === 'direct-link') {
        if (direct_url_view !== '') {
            return (
                <LinkWrapper
                    onClick={handleMatchUrl}
                    data-test='quick-link-tray-item'
                    variant={configState.componentVariants.quickTrayLinkVariant}
                >
                    <div>
                        <ImageWrapper
                            url={link.icon}
                            data-test='quick-link-tray-image'
                        />
                        <SportName data-test='quick-link-tray-label'>{link.label}</SportName>
                    </div>
                </LinkWrapper>
            );
        }
        return null;
    }

    return (
        <NavSportWrapper
            key={link.id}
            onClick={handleRedirect}
            data-test='quick-link-tray-item'
            variant={configState.componentVariants.quickTrayLinkVariant}
        >
            <div>
                <ImageWrapper
                    url={link.icon}
                    data-test='quick-link-tray-image'
                />
                <SportName data-test='quick-link-tray-label'>{link.label}</SportName>
            </div>
        </NavSportWrapper>
    );
});
